export const extractToPlainText = (content = "") =>
  content.replace(/^##\s*/gm, "").replace(/^>\s*/gm, "");

const parseBlocks = (content = "") =>
  content.split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean).map((block) => {
    const lines = block.split("\n").map((l) => l.trim());
    if (/^##/.test(lines[0])) return { type: "title", text: lines[0].replace(/^##\s*/, "") };
    if (lines.every((l) => l.startsWith(">"))) return { type: "signature", lines: lines.map((l) => l.replace(/^>\s*/, "")) };
    return { type: lines.length > 1 ? "lines" : "para", lines };
  });

export const ExtractContent = ({ content, fontSize }) => {
  const blocks = parseBlocks(content);
  const firstPara = blocks.findIndex((b) => b.type === "para");
  return (
    <div data-testid="extract-content" style={{ fontSize }} className="font-serif text-[#1A1A1A] leading-[1.75]">
      {blocks.map((b, i) => {
        if (b.type === "title")
          return (
            <h2 key={i} className="font-serif italic text-[1.6em] leading-tight text-[#2C402E] mt-14 mb-6 first:mt-0 flex items-center gap-4">
              <span className="h-px w-8 bg-[#9E4735]" />{b.text}
            </h2>
          );
        if (b.type === "signature")
          return (
            <div key={i} className="text-right my-10 font-body text-[0.72em] leading-relaxed text-[#4A4A4A]">
              {b.lines.map((l, j) => <p key={j} className={j === 0 ? "font-serif italic text-[1.35em] text-[#1A1A1A] mb-1" : ""}>{l}</p>)}
            </div>
          );
        if (b.type === "lines")
          return (
            <div key={i} className="my-6 space-y-2 border-l border-[#D1CFC7] pl-5">
              {b.lines.map((l, j) => <p key={j}>{l}</p>)}
            </div>
          );
        return (
          <p key={i} className={`my-6 hyphens-auto ${i === firstPara ? "first-letter:float-left first-letter:text-[3.4em] first-letter:leading-[0.85] first-letter:mr-2 first-letter:mt-1 first-letter:text-[#9E4735]" : ""}`}>
            {b.lines[0]}
          </p>
        );
      })}
    </div>
  );
};
